/** QuickHouse — Champ numérique libre : pas de mini/maxi, on peut vider le champ pendant la saisie.
 *  La valeur n'est validée (commit) que si elle est un nombre acceptable ; au blur,
 *  le champ se resynchronise avec la valeur réelle. */
import { useState, useEffect } from 'react';

/**
 * @param value       valeur actuelle (number | null)
 * @param onCommit    appelé avec le nombre saisi (ou null si allowNull et champ vidé)
 * @param positive    n'accepte que > 0 (contrainte du modèle, pas de l'UI)
 * @param nonNegative n'accepte que ≥ 0
 * @param allowNull   champ vidé = null (ex. hauteur de mur héritée de l'étage)
 */
export default function NumField({ value, onCommit, positive = false, nonNegative = false, allowNull = false, ...props }) {
  const [text, setText] = useState(value ?? '');

  // Resynchronise quand la valeur change ailleurs (undo, rechargement, autre poignée…)
  useEffect(() => { setText(value ?? ''); }, [value]);

  const tryCommit = (raw) => {
    if (raw === '' || raw === '-') {
      if (allowNull) onCommit(null);
      return;
    }
    const v = Number(raw);
    if (Number.isNaN(v)) return;
    if (positive && v <= 0) return;
    if (nonNegative && v < 0) return;
    onCommit(v);
  };

  return (
    <input
      type="number"
      step="any"
      value={text}
      onChange={(e) => { setText(e.target.value); tryCommit(e.target.value); }}
      onBlur={() => setText(value ?? '')}
      onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
      {...props}
    />
  );
}
